import styled from 'styled-components';
import tw from 'tailwind.macro';
import { Container } from '../layout/Layout.styles';

const BlogLayoutContainer = styled(Container)`
  ${tw`flex`}
`;

export { BlogLayoutContainer };
